import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Link } from "@mui/material";
import { Field, FormikProvider, useFormik } from "formik";
import * as OFMSUI from "react-bootstrap";
import jsPDF from "jspdf";
import { FaFileExcel } from "react-icons/fa";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import HousingService from "../../Services/HousingService";
import NavigationServicesHeader from "../../Header/NavigationServicesHeader";
import { store } from "../../App";
import { AiOutlineSearch } from "react-icons/ai";
import moment from "moment-timezone";
import * as Yup from "yup";
import ShowAlert from "../alert";

const PFMSReleaseStatusReport = () => {
    const history = useHistory()
    const [data, setData] = useState([])
    const [benData, setBenData] = useState([])
    const [search, setSearch] = useState("")
    const [search2, setSearch2] = useState("")
    const [paymentTable, setPaymentTable] = useState(false)
    const [benTable, setBenTable] = useState(false)
    const [fromDate, setFromDate] = useState(null);
    const [columnType, setColumnType] = useState("")
    const today = new Date();
    const todayDate = new Date();
    let year = todayDate.getUTCFullYear();
    let month = todayDate.getMonth() + 1;
    let tDate = todayDate.getDate();
    if (month < 10) { month = "0" + month; }
    if (tDate < 10) { tDate = "0" + tDate; }
    const maxDate = year + "-" + month + "-" + tDate;

    const validationSchema = Yup.object({
        // paymentType: Yup.string().required("Required"),
        fromdate: Yup.date().required("please select fromdate").max(today, "Should not be Greater than Current date"),
        todate: Yup.date().when(["fromdate"], (fromdate, schema) => { return fromdate ? schema.min(fromdate, "shouldnot be less than from date").max(today, "Should not be Greater than Current date") : schema.max(0); }).required(),
    });

    const formik = useFormik({
        initialValues: { fromdate: "", todate: "" },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            let params = {
                fromdate: moment(values.fromdate).format("YYYY-MM-DD"),
                todate: moment(values.todate).format("YYYY-MM-DD"),
            }
            store.dispatch({ type: "SHOW_SPINNER" });
            HousingService.getSubmitdetailsreport(params).then((res) => {
                setData(res.data)
                setPaymentTable(true)
                setBenTable(false)
                store.dispatch({ type: "HIDE_SPINNER" });
            }).catch((error) => { ShowAlert(error.message, "error") })
        }
    })

    const filteredData = search.length > 0 ? data?.filter((item) => {
        return (item && Object.keys(item).some((key) => {
            const value = item[key];
            return (value !== null && value?.toString().toLowerCase().includes(search.toLowerCase()));
        }));
    }) : data

    const filteredBenData = search2.length > 0 ? benData?.filter((item) => {
        return (item && Object.keys(item).some((key) => {
            const value = item[key];
            return (value !== null && value?.toString().toLowerCase().includes(search2.toLowerCase()));
        }));
    }) : benData

    const getSubmit =(column_type,pa_no) => {
        setColumnType(column_type)
        let formData = new FormData();
        formData.append("pfms_confirm_pano", pa_no);
        store.dispatch({ type: "SHOW_SPINNER" })
        HousingService.getsubmit(formData).then((res) => {
            if (res.data) {
                if(column_type === "Success"){
                    setBenData(res.data?.submitDetailsBenwiseSuccess)
                }else if(column_type === "Failure"){
                    setBenData(res.data?.submitDetailsBenwiseFailure)
                }else{
                    setBenData(res.data?.submitDetailsBenwiseToBeRecon)
                }
                setPaymentTable(false)
                setBenTable(true)
                resetForm()
                
            }
        }).finally(() => {store.dispatch({ type: "HIDE_SPINNER" })})
    }




    const handleGoBack = () => { history.goBack() }

    function generate(table) {
        const pageWidth = 250;
        const pageHeight = 297;
        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight], });
        const headingText = "Material Payment Collection Report";
        const fontSize = 10;
        const textWidth = (doc.getStringUnitWidth(headingText) * fontSize) / doc.internal.scaleFactor;
        const xCoordinate = (pageWidth - textWidth) / 2;
        doc.setFontSize(fontSize);
        doc.text(headingText, xCoordinate, 10);
        doc.autoTable({ html: `#${table}`, theme: "grid", tableWidth: "auto", columnStyles: { 11: { cellWidth: "wrap" }, }, startY: 20, margin: { top: 5, right: 5, bottom: 5, left: 5 }, styles: { fontSize: 8, }, });
        doc.save("PFMSReleaseStatusReport.pdf");
    }
    return (
        <>
            <NavigationServicesHeader />
            <OFMSUI.Container fluid style={{ width: "90%" }}>
                <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={11} lg={11} xl={11} xxl={11} className="page-titlespacing" >
                        <div className="inner-herbpage-service-title1">
                            <h1>PFMS Release Status Report</h1>
                        </div>
                    </OFMSUI.Col>
                    <OFMSUI.Col xs={12} sm={12} md={1} lg={1} xl={1} xxl={1} className="page-titlespacing" >
                        <button type="button" className="btn btn-outline-primary" style={{ textAlign: "right", float: "right", marginTop: "17px",backgroundColor:"#603913",borderColor:"#603913",color:"#fff" }} onClick={handleGoBack} > Back </button>
                    </OFMSUI.Col>
                </OFMSUI.Row>
            </OFMSUI.Container>
            <OFMSUI.Container className="outer-page-content-container " fluid style={{ width: "90%" }} >
                <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                        <ol className="breadcrumb">
                            {/* <li className="breadcrumb-item"> <a href="MaterialAmtTakenConSentFormReport">Back</a> </li> */}
                            <li className="breadcrumb-item"> <a href="Dashboardheader">Dashboard</a> </li>
                            <li className="breadcrumb-item active" aria-current="page"> Report </li>
                        </ol>
                    </OFMSUI.Col>
                </OFMSUI.Row>

                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <OFMSUI.Row>
                            {/* <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <label>Payment Type</label>
                                <Field as="select" name="paymentType" className={formik.touched.paymentType && formik.errors.paymentType ? "form-control is-invalid" : "form-control"}>
                                    <option value="">Select</option>
                                    <option value="Released">Released</option>
                                    <option value="Not_Released">Not Released</option>
                                </Field>
                            </OFMSUI.Col> */}
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <label>From Date</label>
                                <Field type="date" name="fromdate" className={formik.touched.fromdate && formik.errors.fromdate ? "form-control is-invalid" : "form-control"} max={maxDate}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        let from = new Date(e.target.value);
                                        let year = from.getUTCFullYear();
                                        let month = from.getMonth() + 1;
                                        let date = from.getDate();
                                        if (month < 10) { month = "0" + month; }
                                        if (date < 10) { date = "0" + date; }
                                        const minDate = year + "-" + month + "-" + date;
                                        setFromDate(minDate);
                                    }}
                                ></Field>
                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <label>To Date</label>
                                <Field type="date" name="todate" className={formik.touched.todate && formik.errors.todate ? "form-control is-invalid" : "form-control"} min={fromDate ? fromDate : ""} max={maxDate} onChange={(e) => { formik.handleChange(e); }} ></Field>
                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                                <div className="d-grid mt-4">
                                    <button type="submit" className="btn btn-primary" style={{backgroundColor:"#603913",color:"#fff",borderColor:"#603913" }}> Get Details </button>
                                </div>
                            </OFMSUI.Col>
                        </OFMSUI.Row>
                        {paymentTable && <>
                            <OFMSUI.Row>
                                <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div>
                                        </div>
                                        <input type="text" id="" placeholder="" style={{ width: "25%" }} className="form-control input-lg" onChange={(event) => setSearch(event.target.value)} ></input>
                                    </div>
                                </OFMSUI.Col>

                                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                                    <button className="btn btn-danger btn-sm" type="button" onClick={() => generate("my-table")} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                    <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} > <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename="PFMSReleaseStatusReport" sheet="tablexls" buttonText="Excel" > <FaFileExcel style={{ color: "#fff" }} /> </ReactHTMLTableToExcel> </button>
                                </OFMSUI.Col>
                            </OFMSUI.Row>
                            <div style={{ height: "500px", overflow: "auto" }}>
                                <OFMSUI.Table striped bordered hover id="my-table" indexid="index" style={{ marginTop: "15px" }}>
                                <thead className="fw-bold" style={{ position: "sticky", top: "0px",backgroundColor:"#603913",color:"#fff" }} >
                                    <tr className="table_countshead">
                                        <th rowSpan={2}>Sl No.</th>
                                        <th rowSpan={2}>Patch Date</th>
                                        <th rowSpan={2}>PA No.</th>
                                        <th colSpan={2} style={{ textAlign: "center" }}>Total</th>
                                        <th colSpan={2} style={{ textAlign: "center" }}>Success</th>
                                        <th colSpan={2} style={{ textAlign: "center" }}>Failure</th>
                                        <th colSpan={2} style={{ textAlign: "center" }}>To be Reconciliated</th>
                                    </tr>
                                    <tr className="table_countshead">
                                        <th>No. of Payments</th>
                                        <th>Amount</th>
                                        <th>No. of Payments</th>
                                        <th>Amount</th>
                                        <th>No. of Payments</th>
                                        <th>Amount</th>
                                        <th>No. of Payments</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                    <tbody>
                                        {filteredData.length === 0 ? (<tr><td colSpan={11} style={{ textAlign: "center" }}>No Data Found</td></tr>) : (filteredData.map((detail, i) => (
                                           <tr key={i}>
                                           <td>{i + 1}</td>
                                           <td>{detail.path_date}</td>
                                           <td>{detail.pfms_confirm_pano}</td>
                                           <td style={{ textAlign: "right" }}>{detail.no_payments}</td>
                                           <td style={{ textAlign: "right" }}>{detail.total_pay}</td>
                                           <td style={{ textAlign: "right" }}><Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => {getSubmit("Success",detail.pfms_confirm_pano)}}>{detail.no_success}</Link></td>
                                           <td style={{ textAlign: "right" }}>{detail.success_amount}</td>
                                           <td style={{ textAlign: "right" }}><Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => {getSubmit("Failure",detail.pfms_confirm_pano)}}>{detail.no_false}</Link></td>
                                           <td style={{ textAlign: "right" }}>{detail.false_amount}</td>
                                           <td style={{ textAlign: "right" }}><Link style={{ cursor: "pointer", textDecoration: "none" }}  onClick={() => {getSubmit("Recon",detail.pfms_confirm_pano)}}>{detail.tobe_recon}</Link></td>
                                           <td style={{ textAlign: "right" }}>{detail.tobe_recon_amount}</td>
                                       </tr>
                                        )))}
                                    </tbody>
                                    <tfoot className="fw-bold" style={{ position: "sticky", bottom: "0px" }}>
                                        <tr className="table_countshead">
                                            <td colSpan={3} style={{ textAlign: "center" }}>Total</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.no_payments)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.total_pay)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.no_success)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.success_amount)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.no_false)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.false_amount)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.tobe_recon)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData?.reduce((a, v) => (a = parseInt(a) + parseInt(v.tobe_recon_amount)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                        </tr>
                                    </tfoot>
                                </OFMSUI.Table>
                            </div>
                        </>}
                        {/* {detailTable && <>
                            <OFMSUI.Row>
                                <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div>
                                        </div>
                                        <input type="text" id="" placeholder="" style={{ width: "25%" }} className="form-control input-lg" onChange={(event) => setSearch1(event.target.value)} ></input>
                                    </div>
                                </OFMSUI.Col>

                                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                                    <button className="btn btn-danger btn-sm" type="button" onClick={() => generate("my-table1")} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                    <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} > <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table1" filename="UploadResponseFiles" sheet="tablexls" buttonText="Excel" > <FaFileExcel style={{ color: "#fff" }} /> </ReactHTMLTableToExcel> </button>
                                    <button type="button" className="btn btn-primary btn-sm" onClick={backing} style={{ float: "right", marginRight: "3px",backgroundColor:"#603913",borderColor:"#603913",color:"#fff" }} > BACK </button>
                                </OFMSUI.Col>
                            </OFMSUI.Row>
                            <div style={{ height: "500px", overflow: "auto" }}>
                                <OFMSUI.Table striped bordered hover id="my-table1" indexid="index" style={{ marginTop: "15px" }}>
                                    <thead className="fw-bold" style={{ top: "0px", position: "sticky",background:"#603913",color:"#fff" }} >
                                        <tr className="table_countshead">
                                            <th colSpan={tableDistEn ? 10 : tableMandalEn ? 11 : 12} style={{ textAlign: "center" }}>{pfmsNo}</th>
                                        </tr>
                                        {tableHeadEn && <tr className="table_countshead"><th colSpan={10} style={{ textAlign: "center" }}>
                                            {tableMandalEn && <>
                                                <span style={{ marginRight: "0.5rem" }} >District: </span>
                                                <b className="" style={{ marginRight: "0.8rem", color: "#ff5722" }}>{distname}</b>
                                            </>}
                                            {tableVillEn && <>
                                                <span style={{ marginRight: "0.5rem" }} >District: </span>
                                                <b className="" style={{ marginRight: "0.8rem", color: "#ff5722" }}>{distname}</b>
                                                <span style={{ marginRight: "0.5rem" }} > Mandal : </span>
                                                <b className="" style={{ marginRight: "0.8rem", color: "#ff5722" }}>{mandalname}</b></>}</th></tr>
                                        }
                                        <tr className="table_countshead">
                                            <th rowSpan={2}>S No.</th>
                                            {tableDistEn && <th rowSpan={2}>District</th>}
                                            {tableMandalEn && <th rowSpan={2}>Mandal</th>}
                                            {tableVillEn && <th rowSpan={2}>Village</th>}
                                            <th colSpan={2} style={{ textAlign: "center" }}>Total</th>
                                            <th colSpan={2} style={{ textAlign: "center" }}>Success</th>
                                            <th colSpan={2} style={{ textAlign: "center" }}>Fail</th>
                                            <th colSpan={2} style={{ textAlign: "center" }}>To be Reconsilated</th>
                                        </tr>
                                        <tr className="table_countshead">
                                            <th>No. of Beneficiaries</th>
                                            <th>Amount</th>
                                            <th>No. of Beneficiaries</th>
                                            <th>Amount</th>
                                            <th>No. of Beneficiaries</th>
                                            <th>Amount</th>
                                            <th>No. of Beneficiaries</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredDetails.length === 0 ? <tr><td colSpan={12} style={{ textAlign: "center" }}>No Data Found</td></tr> : filteredDetails.map((detail, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                {tableDistEn && <td><Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => { getDrillDownData(detail.dist_code, 0), setTableHeadEn(true), setTableDistEn(false), setTableMandalEn(true), setTableVillEn(false), setDistname(detail.dist_name), setWise("mandalWise") }}>{detail.dist_name}</Link></td>}
                                                {tableMandalEn && <td><Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => { getDrillDownData(detail.dist_code, detail.mandal_code), setTableHeadEn(true), setTableDistEn(false), setTableMandalEn(false), setTableVillEn(true), setDistname(detail.dist_name), setMandalname(detail.mandal_name), setWise("villWise") }}>{detail.mandal_name}</Link></td>}
                                                {tableVillEn && <td>{detail.village_name}</td>}
                                                <td onClick={() => getBenDetails(detail.dist_code, (detail.mandal_code === "null" || detail.mandal_code === null) ? 0 : detail.mandal_code, (detail.village_code === "null" || detail.village_code === null) ? 0 : detail.village_code)} style={{ textAlign: "right" }}><Link style={{ cursor: "pointer", textDecoration: "none" }}>{detail.ben_count}</Link></td>
                                                <td style={{ textAlign: "right" }}>{parseInt(detail.amount).toLocaleString("en-IN", { currency: "INR" })}</td>
                                                <td style={{ textAlign: "right" }}>{detail.success_count}</td>
                                                <td style={{ textAlign: "right" }}>{parseInt(detail.success_amount).toLocaleString("en-IN", { currency: "INR" })}</td>
                                                <td style={{ textAlign: "right" }}>{detail.fail_count}</td>
                                                <td style={{ textAlign: "right" }}>{parseInt(detail.fail_amount).toLocaleString("en-IN", { currency: "INR" })}</td>
                                                <td style={{ textAlign: "right" }}>{detail.initiated_count}</td>
                                                <td style={{ textAlign: "right" }}>{parseInt(detail.initiated_amount).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="fw-bold" style={{ position: "sticky", bottom: "0px" }}>
                                        <tr className="table_countshead">
                                            <td colSpan={2} style={{ textAlign: "center" }}>Total</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.ben_count)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.amount)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.success_count)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.success_amount)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.fail_count)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.fail_amount)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.initiated_count)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                            <td style={{ textAlign: "right" }}>{filteredDetails?.reduce((a, v) => (a = parseInt(a) + parseInt(v.initiated_amount)), 0).toLocaleString("en-IN", { currency: "INR" })}</td>
                                        </tr>
                                    </tfoot>
                                </OFMSUI.Table>
                            </div>
                        </>} */}
                        {benTable && <>
                            <OFMSUI.Row>
                                <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div>
                                        </div>
                                        <input type="text" id="" placeholder="" style={{ width: "25%" }} className="form-control input-lg" onChange={(event) => setSearch2(event.target.value)} ></input>
                                    </div>
                                </OFMSUI.Col>

                                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => generate("my-table2")} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                    <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} > <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table2" filename="UploadResponseFiles" sheet="tablexls" buttonText="Excel" > <FaFileExcel style={{ color: "#fff" }} /> </ReactHTMLTableToExcel> </button>
                                    <button type="button" className="btn btn-primary btn-sm" onClick={() => {setPaymentTable(true); setBenTable(false);setColumnType("") }} style={{ float: "right", marginRight: "3px",backgroundColor:"#603913",borderColor:"#603913",color:"#fff" }} > BACK </button>
                                </OFMSUI.Col>
                            </OFMSUI.Row>
                            <div style={{ height: "500px", overflow: "auto" }}>
                                <OFMSUI.Table striped bordered hover id="my-table2" indexid="index" style={{ marginTop: "15px" }}>
                                <thead className="fw-bold" style={{ position: "sticky", top: "0px",backgroundColor:"#603913",color:"#fff" }} >
                                    <tr className="table_countshead">
                                        <th>Sl No.</th>
                                        <th>Ben ID.</th>
                                        <th>PFMS Code</th>
                                        <th>Ben Name</th>
                                        <th>Acc. No.</th>
                                        <th>Stage</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        {/* <th>Payment Status</th> */}
                                        {columnType === "Failure" && <th>Remarks</th>}
                                    </tr>
                                </thead>
                                    <tbody>
                                        {filteredBenData.length === 0 ? <tr><td colSpan={13} style={{ textAlign: "center" }}>No Data Found</td></tr> : filteredBenData.map((detail, i) => (
                                            <tr key={i}>
                                               <td>{i + 1}</td>
                                                <td>{detail.ben_id}</td>
                                                <td>{detail.pfms_confirm_pano}</td>
                                                <td>{detail.ben_name}</td>
                                                <td>{detail.account_number}</td>
                                                <td>{detail.stage}</td>
                                                <td style={{textAlign:"right"}}>{detail.payment}</td>
                                                <td>{detail.status}</td>
                                                {columnType === "Failure" && <td>{detail.reason_for_failure}</td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="fw-bold">
                                    <tr className="table_countshead">
                                    <td colSpan={6} style={{ textAlign: "center" }}>Total</td>
                                    <td style={{textAlign:"right"}}>{filteredBenData?.reduce((a,v) => a + parseInt(v.payment), 0)}</td>
                                    <td colSpan={columnType === "Failure" ? 2 : 1}></td>
                                    </tr>
                                    </tfoot>
                                </OFMSUI.Table>
                            </div>
                        </>
                        }
                    </Form>
                </FormikProvider>
            </OFMSUI.Container>

        </>
    )
}
export default PFMSReleaseStatusReport